import { render, staticRenderFns } from "./Wellbeing.vue?vue&type=template&id=5f5d1a80"
import script from "./Wellbeing.vue?vue&type=script&lang=js"
export * from "./Wellbeing.vue?vue&type=script&lang=js"
import style0 from "./Wellbeing.vue?vue&type=style&index=0&id=5f5d1a80&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports